import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useCart } from '#src/hooks/useCart.ts';

import type { useEligibleForCartPromo_anyCard } from './__generated__/useEligibleForCartPromo.graphql.ts';

export const useEligibleForCartPromo = () => {
  const { livePromos } = useCart();

  const eligibleForCartPromo = (anyCard: useEligibleForCartPromo_anyCard) => {
    return livePromos.some(promo => {
      const { eligibilityRules } = promo;
      if (!eligibilityRules) return false;
      const { eligibleCartCardsCount, eligibleCollections } = eligibilityRules;
      if (eligibleCartCardsCount) {
        return true;
      }
      if (eligibleCollections) {
        return eligibleCollections.cardCollections?.some(collection => {
          return (
            collection.rarity === anyCard.rarityTyped &&
            collection.anyTeam?.slug === anyCard.anyTeam.slug &&
            collection.sportSeason?.name === anyCard.sportSeason.name
          );
        });
      }
      return false;
    });
  };
  return {
    eligibleForCartPromo,
  };
};

useEligibleForCartPromo.fragments = {
  anyCard: gql`
    fragment useEligibleForCartPromo_anyCard on AnyCardInterface {
      slug
      name
      rarityTyped
      anyTeam {
        slug
      }
      sportSeason {
        name
      }
    }
  ` as TypedDocumentNode<useEligibleForCartPromo_anyCard>,
};
